<header class="main-content admin-header">
  <div class="header-left">
    <h5>{{ nomeFantasia }}</h5>
    <span>Gestão dos módulos e cadastros do Institucional</span>
  </div>

  <div class="header-right">
    <button
      type="button"
      class="btn header-theme-button"
      title="Personalizar aparência"
      aria-label="Personalizar aparência"
      (click)="abrirPainelTema()">
      <i-lucide name="palette" size="20"></i-lucide>
    </button>

    <app-notificacoes></app-notificacoes>

    <div class="dropdown-wrapper">
      <div class="user-info" role="button" tabindex="0" title="Abrir menu do perfil" (click)="alternarPerfil()">
        <div class="avatar">
          <img *ngIf="previewImage; else avatarIniciais" [src]="previewImage" alt="Avatar do usuário" />
          <ng-template #avatarIniciais>
            {{ iniciais(nomeExibido) }}
          </ng-template>
        </div>
        <div class="user-text">
          <strong>{{ nomeExibido }}</strong>
          <span class="nivel-perfil">{{ perfil }}</span>
        </div>
        <span><i-lucide class="header-chevron" name="chevron-down" size="15"></i-lucide></span>
      </div>

      <div class="dropdown profile" *ngIf="exibirPerfil">
        <div class="profile-header">
          <div class="avatar details">
            <img *ngIf="previewImage; else avatarIniciaisDetalhe" [src]="previewImage" alt="Avatar do usuário" />
            <ng-template #avatarIniciaisDetalhe>{{ iniciais(nomeExibido) }}</ng-template>
          </div>
          <div class="drop-details">
            <strong class="name-profile">{{ nomeExibido }}</strong>
            <small class="email">{{ email }}</small>
            <span class="role">{{ perfil }}</span>
          </div>
        </div>

        <a class="dropdown-item" role="button" title="Meu Perfil" (click)="meuPerfil()">
          <i-lucide name="user" size="16" color="#717182"></i-lucide> Meu Perfil
        </a>
        <a class="dropdown-item" role="button" title="Configurações" (click)="configuracao()">
          <i-lucide name="settings" size="16" color="#717182"></i-lucide> Configurações
        </a>
        <a class="dropdown-item" role="button" title="Trocar de Cliente" (click)="trocarCliente()">
          <i-lucide name="arrow-right-left" size="16" color="#717182"></i-lucide> Trocar de Cliente
        </a>
        <a class="dropdown-item danger" role="button" title="Sair" (click)="sair()">
          <i-lucide name="log-out" size="16" color="#717182"></i-lucide> Sair
        </a>
      </div>
    </div>
  </div>
</header>
